import * as Sentry from "@sentry/react";

// The name represents the category that the error will fall under in Sentry.
export const logDataToSentry = (name: string, data: unknown) => {
	if (process.env.VITE_SENTRY_ENV !== "prod") console.info(name, data);
	Sentry.withScope((scope) => {
		scope.setLevel("info");
		scope.setTag("name", name);
		scope.setExtra("data", data);
		Sentry.captureMessage(name);
	});
};
